import { render, staticRenderFns } from "./add_art.vue?vue&type=template&id=61d5ea75&scoped=true&"
import script from "./add_art.vue?vue&type=script&lang=js&"
export * from "./add_art.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d5ea75",
  null
  
)

export default component.exports